module.exports = __webpack_public_path__ + "img/vartext2en.66569a2b.svg";